export default __webpack_public_path__ + "static/img_5-5265160650b5edaccfdd543c2a82dbf1.png";